import React, { useState } from "react";
import ProccessApp from "./Subprocess/ProccessApp";
import { getWfPhasesColor } from "../../services/appService";

const JourneySteps = (props) => {
  const [subProccessShowHide, setSubProccessShowHide] = useState(false);
  const [selectedSubProcessTask, setSelectedSubProcessTask] = useState(null);

  const {
    custApp,
    handleJorneySteps,
    candidateObj,
    journeyShowHide = true,
    selectedTaskId,
  } = props;

  const totalPhases = custApp?.allWfPhase
    ? custApp.allWfPhase.filter(
      (x) =>
        x.wfPhase !== "" &&
        x.wfPhase !== "Application" &&
        x.wfPhase !== "Rejected",
    )
    : [];

  const allTasks = custApp?.workflowTasks
    ? custApp.workflowTasks
      .filter(
        (x) =>
          x.itemType !== 3 &&
          x.itemType !== 2 &&
          x.itemType !== 5 &&
          x.itemType !== 4,
      )
      .sort((a, b) => a.orderNumber - b.orderNumber)
    : [];

  console.log("JourneySteps Rendered with props:", allTasks);

  const handleProcessShowHide = (tsk) => {
    if (tsk) {
      setSelectedSubProcessTask(tsk);
      setSubProccessShowHide(true);
      return;
    }
    setSubProccessShowHide(false);
  };

  const getTaskLabel = (task) =>
    task.itemName === "Verify Insurance Expiry Date"
      ? "Verify Insurance"
      : task.itemName;

  const getWfPhaseStatusMeta = (phase) => {
    const pAll = allTasks.filter(
      (x) => x.wfPhase === phase && x.itemType === 1,
    );
    const dAll = allTasks.filter(
      (x) => x.wfPhase === phase && x.taskDoneStatus === 4 && x.itemType === 1,
    );
    const rAll = allTasks.filter(
      (x) =>
        x.wfPhase === phase &&
        x.taskDoneStatus === 2 &&
        x.taskDoneStatus !== 4 &&
        x.itemType === 1,
    );

    if (rAll.length > 0) {
      return {
        icon: "fa-cog fa-spin",
        label: "In progress",
        status: "active",
      };
    }

    if (dAll.length > 0 && dAll.length === pAll.length) {
      return {
        icon: "fa-check",
        label: "Done",
        status: "done",
      };
    }

    return {
      icon: "fa-clock-o",
      label: "Pending",
      status: "pending",
    };
  };

  return (
    <div className={`journey-sidebar-rich ${!journeyShowHide ? "collapsed" : ""}`}>
      <style>{`
        .journey-sidebar-rich {
          width: 100%;
          color: #1e293b;
          font-family: "Inter", "Segoe UI", Roboto, sans-serif;
          transition: all 0.3s ease;
          padding: 15px;
        }
        .journey-sidebar-rich * { box-sizing: border-box; }
        
        .journey-timeline {
          position: relative;
          padding: 0;
          list-style: none;
          margin: 0;
        }
        
        /* Define Phase Color Variables */
        .journey-phase-item.btn-primary { --phase-clr: #3b82f6; --phase-bg: #eff6ff; }
        .journey-phase-item.btn-info { --phase-clr: #06b6d4; --phase-bg: #ecfeff; }
        .journey-phase-item.btn-warning { --phase-clr: #f59e0b; --phase-bg: #fffbeb; }
        .journey-phase-item.btn-success { --phase-clr: #22c55e; --phase-bg: #f0fdf4; }
        .journey-phase-item.btn-wf2-default { --phase-clr: #eab308; --phase-bg: #fef9c3; }
        .journey-phase-item.btn-wf3-default { --phase-clr: #10b981; --phase-bg: #ecfdf5; }
        .journey-phase-item.btn-wf4-default { --phase-clr: #ef4444; --phase-bg: #fef2f2; }
        .journey-phase-item.btn-wf5-default { --phase-clr: #f97316; --phase-bg: #fff7ed; }
        .journey-phase-item.btn-wf6-default { --phase-clr: #8b5cf6; --phase-bg: #f5f3ff; }
        .journey-phase-item.btn-default { --phase-clr: #64748b; --phase-bg: #f8fafc; }

        /* Timeline as item segments */
        .journey-phase-item::before {
          content: "";
          position: absolute;
          top: 33px; /* Start at icon center */
          bottom: -33px; /* Connect to next icon center */
          left: 33px; /* Center of icon: 4px pad + 8px header pad + 21px icon radius */
          width: 2px;
          background: #cbd5e1;
          z-index: 1;
          transition: all 0.3s ease;
        }
        
        .journey-phase-item.done::before {
          background: var(--phase-clr) !important;
        }

        .journey-phase-item.active::before {
          background: linear-gradient(to bottom, var(--phase-clr), #cbd5e1) !important;
        }

        .journey-phase-item.pending::before {
          background: #cbd5e1 !important;
        }

        .journey-phase-item:last-child::before {
          display: none !important;
        }

        .journey-sidebar-rich.collapsed .journey-phase-item::before {
          display: none !important;
        }

        .journey-phase-item {
          position: relative;
          margin-bottom: 24px;
          z-index: 2;
          padding: 4px;
          border-radius: 14px;
          transition: all 0.3s ease;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        .journey-phase-item.active {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        .journey-phase-header {
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
          padding: 4px 12px 4px 4px;
          border-radius: 16px;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          background: #ffffff;
          border: 2px solid #cbd5e1;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
          position: relative;
          z-index: 2;
        }

        .journey-phase-item.done .journey-phase-header {
          border-color: var(--phase-clr) !important;
          background: #ffffff !important;
        }

        .journey-phase-item.active .journey-phase-header {
          border-color: var(--phase-clr) !important;
          background: #ffffff !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
        }

        .journey-phase-item.pending .journey-phase-header {
          border-color: #cbd5e1 !important;
          background: #f8fafc !important;
          box-shadow: none;
          cursor: not-allowed;
        }

        .journey-phase-item.pending .journey-phase-header:hover {
          transform: none !important;
          box-shadow: none !important;
          border-color: #cbd5e1 !important;
        }

        .journey-phase-header:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 12px rgba(15, 23, 42, 0.04);
          border-color: var(--phase-clr) !important;
        }


        .journey-sidebar-rich.collapsed .journey-phase-header {
          justify-content: center;
          margin-bottom: 0;
          padding: 0;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        .journey-phase-icon {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ffffff !important;
          border: 2px solid var(--phase-clr) !important;
          color: var(--phase-clr) !important;
          font-size: 16px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          flex-shrink: 0;
          z-index: 2;
        }

        .journey-phase-item.done .journey-phase-icon {
          background: var(--phase-clr) !important;
          color: #ffffff !important;
          border: 2px solid var(--phase-clr) !important;
        }

        .journey-sidebar-rich.collapsed .journey-phase-icon {
          width: 38px;
          height: 38px;
          font-size: 14px;
        }

        /* Active phase pop */
        .journey-phase-item.active .journey-phase-icon {
          transform: scale(1.05);
          background: var(--phase-bg) !important;
          color: var(--phase-clr) !important;
          border: none !important;
          box-shadow: none !important;
        }

        /* Pending phase style */
        .journey-phase-item.pending .journey-phase-icon {
          background: #f8fafc !important;
          color: #94a3b8 !important;
          border: 2px solid #cbd5e1 !important;
          box-shadow: none;
        }

        .journey-phase-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-width: 0;
          flex: 1;
          gap: 12px;
        }

        .journey-sidebar-rich.collapsed .journey-phase-info {
          display: none;
        }

        .journey-phase-name {
          font-size: 12px;
          font-weight: 850;
          color: #0f172a;
          margin: 0;
          white-space: nowrap;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        .journey-phase-status-badge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 6px;
          font-size: 9px;
          font-weight: 800;
          text-transform: uppercase;
          width: fit-content;
          border: 1px solid transparent;
        }
        .journey-phase-status-badge.active { background: var(--phase-bg); color: var(--phase-clr); border-color: var(--phase-clr); }
        .journey-phase-status-badge.done { background: #f0fdf4; color: #166534; border-color: #dcfce7; }
        .journey-phase-status-badge.pending { background: #f8fafc; color: #64748b; border-color: #f1f5f9; }

        .journey-tasks {
          margin-left: 50px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-top: 8px;
          padding-right: 8px;
        }

        .journey-sidebar-rich.collapsed .journey-tasks {
          display: none;
        }

        .journey-task-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          border-radius: 10px;
          background: transparent;
          border: 1px solid transparent;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
          position: relative;
        }

        .journey-task-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          min-width: 0;
          flex: 1;
        }

        .journey-task-row:hover {
          background: #ffffff;
          border-color: var(--phase-clr) !important;
          opacity: 0.9;
          transform: translateX(6px);
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
        }

        .journey-task-row.active {
          background: #ffffff;
          color: var(--phase-clr) !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: none !important;
        }

        .journey-task-row.done {
          background: #ffffff;
          border: 1px solid #e2e8f0 !important;
        }

        .journey-task-indicator {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 10px;
          transition: all 0.3s ease;
          border: 2px solid #cbd5e1;
          background: #ffffff;
        }

        .journey-task-row.pending .journey-task-indicator {
          border-color: #e2e8f0;
        }

        .journey-task-row.active .journey-task-indicator {
          border-color: var(--phase-clr) !important;
          background: var(--phase-bg) !important;
          color: var(--phase-clr) !important;
          box-shadow: 0 0 0 3px var(--phase-bg) !important;
          animation: rt-pulse 2s infinite;
        }

        .journey-task-row.selected .journey-task-indicator {
          border-color: var(--phase-clr) !important;
          background: #ffffff !important;
          color: var(--phase-clr) !important;
          box-shadow: 0 0 0 3px var(--phase-bg) !important;
          animation: none !important;
        }

        @keyframes rt-pulse {
          0% { box-shadow: 0 0 0 0 var(--phase-bg); }
          70% { box-shadow: 0 0 0 6px rgba(0, 0, 0, 0); }
          100% { box-shadow: 0 0 0 0 var(--phase-bg); }
        }

        .journey-task-row.done .journey-task-indicator {
          background: #22c55e;
          border-color: #22c55e;
          color: #ffffff;
        }

        .journey-task-row.pending,
        .journey-task-row.disabled {
          background: #ffffff;
          border: 1px solid #e2e8f0 !important;
          cursor: not-allowed;
          opacity: 0.65;
        }

        .journey-task-row.pending .journey-task-text,
        .journey-task-row.disabled .journey-task-text {
          color: #94a3b8 !important;
          text-decoration: none !important;
        }

        .journey-task-row.pending:hover,
        .journey-task-row.disabled:hover {
          background: #ffffff !important;
          border-color: #e2e8f0 !important;
          transform: none !important;
          box-shadow: none !important;
        }

        .journey-task-row.pending:hover .journey-task-text,
        .journey-task-row.disabled:hover .journey-task-text {
          color: #94a3b8 !important;
          text-decoration: none !important;
        }

        .journey-task-row.selected {
          background: #ffffff !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          cursor: pointer;
          opacity: 1;
          box-shadow: inset 4px 0 0 var(--phase-clr), 0 2px 8px rgba(15, 23, 42, 0.06) !important;
          transform: none !important;
        }

        .journey-task-text {
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #2563eb;
          transition: color 0.2s ease;
        }

        .journey-task-row.active .journey-task-text {
          color: #2563eb !important;
          font-weight: 750;
        }

        .journey-task-row.selected .journey-task-text {
          color: #0f172a !important;
          font-weight: 850;
        }

        .journey-task-row.done .journey-task-text {
          color: #2563eb;
        }

        .journey-task-row:hover .journey-task-text {
          color: #2563eb !important;
        }

        .journey-task-row.selected:hover {
          background: #ffffff !important;
          border-color: var(--phase-clr) !important;
          transform: none !important;
          box-shadow: inset 4px 0 0 var(--phase-clr), 0 4px 10px rgba(15, 23, 42, 0.08) !important;
        }

        .journey-task-row.selected:hover .journey-task-text {
          color: #0f172a !important;
        }
        
        .journey-subprocess-group {
          margin-top: 10px;
          margin-bottom: 10px;
          border-left: 3px solid var(--phase-clr) !important;
          padding-left: 12px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          position: relative;
          background: linear-gradient(90deg, var(--phase-bg), rgba(255,255,255,0));
          border-radius: 0 12px 12px 0;
          padding-top: 8px;
          padding-bottom: 8px;
          padding-right: 8px;
        }
        
        .journey-sidebar-rich.collapsed .journey-subprocess-group {
          display: none;
        }

        .journey-subprocess-header {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          font-size: 9px;
          font-weight: 850;
          color: var(--phase-clr) !important;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 2px;
          padding: 0 4px;
          width: fit-content;
        }

        .journey-subprocess-icon {
          font-size: 11px;
          color: var(--phase-clr) !important;
        }

        .journey-task-row.subprocess {
          padding: 10px 12px;
          background: #ffffff;
          border: 1px solid #dbe4f0;
          border-radius: 10px;
          box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);
          margin-bottom: 2px;
        }

        .journey-task-row.subprocess:hover {
          background: #ffffff;
          border-color: var(--phase-clr) !important;
          transform: translateX(4px);
          box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
        }

        .journey-task-row.subprocess.active {
          background: #ffffff;
          border: 1px solid #e2e8f0 !important;
          box-shadow: none !important;
        }

        .journey-task-row.subprocess.selected {
          background: #ffffff !important;
          border-color: #cbd5e1 !important;
          box-shadow: inset 4px 0 0 var(--phase-clr), 0 2px 8px rgba(15, 23, 42, 0.06) !important;
        }

        .journey-task-row.subprocess .journey-task-indicator {
          width: 28px;
          height: 28px;
          border-radius: 9px;
          border-width: 1.5px;
          font-size: 12px;
          color: var(--phase-clr) !important;
          border-color: var(--phase-clr) !important;
          background: var(--phase-bg) !important;
        }

        .journey-task-row.subprocess.active .journey-task-indicator {
          border-color: var(--phase-clr) !important;
          background: var(--phase-bg) !important;
          color: var(--phase-clr) !important;
          box-shadow: 0 0 0 2px var(--phase-bg) !important;
          animation: rt-pulse-sub 2s infinite;
        }

        .journey-task-row.subprocess.done .journey-task-indicator {
          background: var(--phase-clr) !important;
          border-color: var(--phase-clr) !important;
          color: #ffffff !important;
        }

        .journey-subprocess-copy {
          display: flex;
          flex-direction: column;
          gap: 3px;
          min-width: 0;
          flex: 1;
        }

        .journey-subprocess-meta {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          color: #64748b;
          font-size: 10px;
          font-weight: 700;
          line-height: 1.2;
        }

        .journey-subprocess-open {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 8px;
          color: var(--phase-clr) !important;
          background: var(--phase-bg) !important;
          border: 1px solid rgba(148, 163, 184, 0.35);
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .journey-task-row.subprocess:hover .journey-subprocess-open {
          transform: translateX(2px);
          border-color: var(--phase-clr) !important;
        }

        @keyframes rt-pulse-sub {
          0% { box-shadow: 0 0 0 0 var(--phase-bg); }
          70% { box-shadow: 0 0 0 4px rgba(0, 0, 0, 0); }
          100% { box-shadow: 0 0 0 0 var(--phase-bg); }
        }

        /* Skeleton Styles */
        @keyframes skeleton-pulse {
          0% { background-color: #f1f5f9; }
          50% { background-color: #cbd5e1; }
          100% { background-color: #f1f5f9; }
        }

        .journey-skeleton-pulse {
          animation: skeleton-pulse 1.8s infinite ease-in-out;
        }

        .journey-skeleton-item {
          position: relative;
          margin-bottom: 24px;
          padding: 4px;
          z-index: 2;
        }

        .journey-skeleton-item::before {
          content: "";
          position: absolute;
          top: 33px;
          bottom: -33px;
          left: 33px;
          width: 2px;
          background: #cbd5e1;
          z-index: 1;
        }

        .journey-skeleton-item:last-child::before {
          display: none !important;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-item::before {
          display: none !important;
        }

        .journey-skeleton-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 4px 12px 4px 4px;
          border-radius: 16px;
          background: #ffffff;
          border: 2px solid #e2e8f0;
          position: relative;
          z-index: 2;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-header {
          justify-content: center;
          padding: 0;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
        }

        .journey-skeleton-icon {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          flex-shrink: 0;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-icon {
          width: 38px;
          height: 38px;
        }

        .journey-skeleton-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-width: 0;
          flex: 1;
          gap: 12px;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-info {
          display: none;
        }

        .journey-skeleton-name {
          height: 12px;
          width: 45%;
          border-radius: 4px;
        }

        .journey-skeleton-badge {
          height: 16px;
          width: 50px;
          border-radius: 6px;
        }

        .journey-skeleton-tasks {
          margin-left: 50px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-top: 8px;
          padding-right: 8px;
        }

        .journey-sidebar-rich.collapsed .journey-skeleton-tasks {
          display: none;
        }

        .journey-skeleton-task-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          border-radius: 10px;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          opacity: 0.65;
        }

        .journey-skeleton-task-indicator {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .journey-skeleton-task-text {
          height: 10px;
          width: 60%;
          border-radius: 3px;
        }

        /* Empty State Styles */
        .journey-empty-state {
          text-align: center;
          border: 2px dashed #e2e8f0;
          border-radius: 16px;
          padding: 24px 16px;
          background: #f8fafc;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          list-style: none;
        }

        .journey-empty-icon {
          color: #94a3b8;
          margin-bottom: 12px;
          transition: all 0.3s ease;
        }

        .journey-empty-title {
          font-size: 13px;
          font-weight: 650;
          color: #475569;
          margin: 0 0 6px 0;
        }

        .journey-empty-desc {
          font-size: 11px;
          color: #64748b;
          margin: 0;
          line-height: 1.4;
        }

        .journey-sidebar-rich.collapsed .journey-empty-state {
          border: none;
          background: transparent;
          padding: 12px 0;
        }

        .journey-sidebar-rich.collapsed .journey-empty-icon {
          font-size: 20px;
          margin-bottom: 0;
        }

        .journey-sidebar-rich.collapsed .journey-empty-info {
          display: none;
        }
      `}</style>

      <ul className="journey-timeline">
        {!custApp ? (
          <>
            {/* Skeleton Item 1: Header + 2 Tasks */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
              <div className="journey-skeleton-tasks">
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
              </div>
            </li>
            {/* Skeleton Item 2: Header + 1 Task */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
              <div className="journey-skeleton-tasks">
                <div className="journey-skeleton-task-row">
                  <div className="journey-skeleton-task-indicator journey-skeleton-pulse" />
                  <div className="journey-skeleton-task-text journey-skeleton-pulse" />
                </div>
              </div>
            </li>
            {/* Skeleton Item 3: Header Only */}
            <li className="journey-skeleton-item">
              <div className="journey-skeleton-header">
                <div className="journey-skeleton-icon journey-skeleton-pulse" />
                <div className="journey-skeleton-info">
                  <div className="journey-skeleton-name journey-skeleton-pulse" />
                  <div className="journey-skeleton-badge journey-skeleton-pulse" />
                </div>
              </div>
            </li>
          </>
        ) : totalPhases.length === 0 ? (
          <li className="journey-empty-state">
            <i className="fa fa-folder-open-o journey-empty-icon" style={{ fontSize: "28px" }} aria-hidden="true"></i>
            <div className="journey-empty-info">
              <h5 className="journey-empty-title">No Phases Found</h5>
              <p className="journey-empty-desc">There are no workflow phases defined for this journey.</p>
            </div>
          </li>
        ) : (
          totalPhases.map((item, key) => {
            const phaseMeta = getWfPhaseStatusMeta(item.wfPhase);
            const phaseColorClass = getWfPhasesColor(item.wfPhase);
            const phaseTasks = allTasks.filter((x) => x.wfPhase === item.wfPhase);
            const orderedPhaseBlocks = phaseTasks.reduce((blocks, task) => {
              if (task.itemType === 14) {
                const lastBlock = blocks[blocks.length - 1];
                if (lastBlock?.type === "subprocess") {
                  lastBlock.tasks.push(task);
                } else {
                  blocks.push({ type: "subprocess", tasks: [task] });
                }
                return blocks;
              }

              if (task.itemType === 1) {
                blocks.push({ type: "task", task });
              }

              return blocks;
            }, []);

            return (
              <li key={item.wfPhase || key} className={`journey-phase-item ${phaseMeta.status} ${phaseColorClass}`}>
                <div className="journey-phase-header" onClick={() => phaseMeta.status !== "pending" && handleJorneySteps(allTasks.find(x => x.wfPhase === item.wfPhase)?.wiid)}>
                  <div className={`journey-phase-icon ${phaseColorClass}`}>
                    <i className={`fa ${phaseMeta.icon}`} aria-hidden="true"></i>
                  </div>
                  <div className="journey-phase-info">
                    <h5 className="journey-phase-name">{item.wfPhase}</h5>
                    <span className={`journey-phase-status-badge ${phaseMeta.status}`}>
                      {phaseMeta.label}
                    </span>
                  </div>
                </div>

                <div className="journey-tasks">
                  {orderedPhaseBlocks.map((block, blockIndex) => {
                    if (block.type === "subprocess") {
                      return (
                        <div className="journey-subprocess-group" key={`subprocess-${item.wfPhase}-${blockIndex}`}>
                          <div className="journey-subprocess-header">
                            <i className="fa fa-sitemap journey-subprocess-icon" aria-hidden="true"></i>
                            <span>Subprocess</span>
                          </div>
                          {block.tasks.map((task) => {
                            const isDone = task.taskDoneStatus === 4;
                            const isActive = task.taskDoneStatus === 2;
                            const isPending = task.taskDoneStatus === 0;
                            const statusLabel = isDone ? "Completed" : isActive ? "In progress" : "Not available yet";

                            return (
                              <div
                                key={task.itemId || task.wiid || task.itemName}
                                className={`journey-task-row subprocess ${isDone ? "done" : ""} ${isActive ? "active" : ""} ${isPending ? "disabled" : ""}`}
                                onClick={() => task.taskDoneStatus > 0 && handleProcessShowHide(task)}
                                title={task.taskDoneStatus > 0 ? "Open subprocess details" : "Subprocess is not available yet"}
                              >
                                <div className="journey-task-indicator">
                                  <i className={`fa ${isDone ? "fa-check" : "fa-code-fork"}`} aria-hidden="true" />
                                </div>
                                <div className="journey-task-content">
                                  <div className="journey-subprocess-copy">
                                    <span className="journey-task-text">{task.itemName}</span>
                                    <span className="journey-subprocess-meta">
                                      <i className="fa fa-window-restore" aria-hidden="true" />
                                      {statusLabel} · Opens in subprocess workspace
                                    </span>
                                  </div>
                                  <span className="journey-subprocess-open" aria-hidden="true">
                                    <i className="fa fa-external-link" />
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }

                    const task = block.task;
                    const taskLabel = getTaskLabel(task);
                    const isDone = task.taskDoneStatus === 4;
                    const isActive = task.taskDoneStatus === 2;
                    const isSelected = String(task.wiid) === String(selectedTaskId);

                    return (
                      <div
                        key={task.wiid}
                        className={`journey-task-row ${isDone ? "done" : ""} ${isActive ? "active" : ""} ${isSelected ? "selected" : ""} ${!isDone && !isActive ? "pending" : ""}`}
                        onClick={() => (isDone || isActive) && handleJorneySteps(task.wiid)}
                      >
                        <div className="journey-task-indicator">
                          {isSelected ? <i className="fa fa-dot-circle-o" /> : isDone && <i className="fa fa-check" />}
                        </div>
                        <span className="journey-task-text">{taskLabel}</span>
                      </div>
                    );
                  })}
                </div>
              </li>
            );
          })
        )}
      </ul>
      {selectedSubProcessTask && (
        <ProccessApp
          processShowHide={subProccessShowHide}
          handleProcessShowHide={handleProcessShowHide}
          subProccessTask={selectedSubProcessTask}
          candidateObj={candidateObj}
        />
      )}
    </div>
  );
};

export default JourneySteps;
